// extracted by mini-css-extract-plugin
export default {"attributes":"Attributes_attributes__Vo6Nu","attribute-card":"Attributes_attribute-card__56219","is-active":"Attributes_is-active__w4uv+"};